module.exports = __webpack_public_path__ + "img/ic_autorecharge.02de600f.png";